import { useEffect, useState } from "react";

const SLIDES = [
  { src: "/img/hero_exterior.jpg", alt: "Eksterior UPLINK COFFEE", pos: "object-[65%_center]" },
  { src: "/img/hero_interior.jpg", alt: "Interior dan teras UPLINK COFFEE", pos: "object-[60%_center]" },
];

export const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative overflow-hidden min-h-[560px] sm:min-h-[620px] flex items-end sm:items-center" data-testid="hero-section">
      {SLIDES.map((s, i) => (
        <img key={s.src} src={s.src} alt={s.alt} data-testid={`hero-slide-${i}`}
          className={`absolute inset-0 w-full h-full object-cover ${s.pos} transition-opacity duration-[1500ms] ${i === idx ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink/30 to-transparent sm:hidden" />
      <div className="wrap relative w-full pt-16 pb-14 sm:py-24">
        <div className="max-w-[360px] bg-white/85 rounded-2xl p-4 sm:p-5 shadow-[0_20px_50px_-25px_rgba(23,58,96,0.5)] border border-white/60" data-testid="hero-text-card">
          <span className="rise inline-block bg-sage-100 border border-sage-200 text-forest text-[10px] font-bold tracking-[0.12em] px-2.5 py-1 rounded-full" data-testid="hero-badge">
            UPLINK!
          </span>
          <h1 className="rise font-serif font-semibold text-ink text-2xl sm:text-3xl lg:text-4xl leading-[1.08] tracking-tight mt-3" style={{ animationDelay: "80ms" }}>
            Ngopi santai.<br />Koneksi makin luas.
          </h1>
          <p className="rise text-xs sm:text-sm text-ink/80 mt-2.5 leading-relaxed" style={{ animationDelay: "160ms" }}>
            Tempat bertemu teman, bertukar ide, dan membuka peluang baru. Semua ditemani kopi dan makanan favoritmu.
          </p>
          <div className="flex gap-2 mt-4">
            {SLIDES.map((s, i) => (
              <button key={s.src} onClick={() => setIdx(i)} aria-label={s.alt} data-testid={`hero-dot-${i}`}
                className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-8 bg-forest" : "w-4 bg-forest/30"}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
